'use strict';
var SoaModel = require('bunsen/models/SoaModel');
var PortfolioItem = module.exports = SoaModel.extend();
var Backbone = require('dibs-backbone');
var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var Item = require('bunsen/models/inventory/Item');

_.extend(PortfolioItem.prototype, {

    idAttribute: 'id',

    url: function () {
        if (this.get('id')) {
            return endpoints.portfolioItem(this.get('id'));
        } else {
            return endpoints.portfolioAddItem(0, this.get('item.id')); // requires userId in query param
        }
    },

    defaults: {
        createdDate: '',
        item: {}
    },

    relations: SoaModel.createRelations([
        {
            key: 'item',
            relatedModel: Item,
            type: Backbone.One
        }
    ])
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/portfolio/PortfolioItemModel.js
// module id = 295
// module chunks = 63